module.exports = __webpack_public_path__ + "static/media/country_ci.a640b17e.webp";